import { IUserFavorite } from 'api/hooks/use-favorite-list-item';
import styles from './styles.module.scss';
import iconDelete from 'assets/images/icon-delete-cross.svg';
import { getName } from 'lib/utils';

interface IFavoriteListItemUser {
  user: IUserFavorite;
  indexOnList: number;
  onDelete: (id: number) => void;
}

const FavoriteListItemUser = ({ user, onDelete, indexOnList }: IFavoriteListItemUser) => {
  return (
    <div className={styles.container}>
      <div>{indexOnList}</div>
      <div>{getName(user.fullname)}</div>
      <div onClick={() => onDelete(user.id)}>
        <img src={iconDelete} alt='menu' />
      </div>
    </div>
  );
};

export default FavoriteListItemUser;
